import React from "react";
import BasePage from "./base-page.jsx";

// doesn't do an auth check, default layout does auth checks
const LoginLayout = ({ children, title }) => {
  React.useEffect(() => {
    document.title = title;
  }, [title]);

  return <BasePage>{children}</BasePage>;
};

export default LoginLayout;
